var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-parallax',{attrs:{"src":"https://cdn.vuetifyjs.com/images/parallax/material.jpg"}})}
var staticRenderFns = []

export { render, staticRenderFns }